import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { useStateContext } from "../contexts/ContextProvider";
import { links } from "../data/dummy";
import { RiDashboardFill, RiContactsLine } from "react-icons/ri";
import { FaUsers, FaAws } from "react-icons/fa";
import { AiOutlineUsergroupAdd, AiTwotoneFolderOpen } from "react-icons/ai";
import { LiaHtml5 } from "react-icons/lia";
import { AiOutlineMenu } from "react-icons/ai";

const Sidebar = () => {
  const { currentColor, activeMenu, setActiveMenu, screenSize, currentMode } =
    useStateContext();
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState("");

  useEffect(() => {
    try {
      const userDetails = localStorage.getItem("userData");
      if (userDetails) {
        const { role } = JSON.parse(userDetails);
        console.log(links, role);

        setUserRole(role || "");
      } else {
        console.error("User details not found in local storage.");
        // Handle the case when user details are not found in local storage
      }
    } catch (error) {
      console.error("Error parsing user details from local storage:", error);
      // Handle the error when parsing user details fails
    }
  }, []);

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const sidebarClass = activeMenu ? "w-64" : "w-20";

  const handleActiveMenuToggle = () => {
    setActiveMenu(!activeMenu);
  };

  const activeLink =
    "flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-white text-md m-2 no-underline";
  const normalLink =
    "flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover-text-black hover-bg-light-gray m-2 no-underline";
  const handleActiveMenu = () => setActiveMenu(!activeMenu);

  const NavButton = ({ title, customFunc, icon, color, dotColor }) => (
    <TooltipComponent content={title} position="BottomRight">
      <button
        type="button"
        onClick={() => customFunc()}
        // style={{ color }}
        // style={{ color, marginLeft:"80%" }}
        style={activeMenu ? { color, marginLeft: "80%" } : { color }}
        className="relative text-xl rounded-full p-4 hover:bg-light-gray"
      >
        <span
          style={{ background: dotColor }}
          className="absolute inline-flex rounded-full h-2 w-2 right-2 top-2"
        />
        {icon}
      </button>
    </TooltipComponent>
  );

  return (
    <>
      <div
        className={`${sidebarClass} fixed sidebar dml-3 h-screen md:overflow-y-auto overflow-x-hidden pb-10`}
        style={{
          background: currentMode === "Dark" ? "#33373E" : "#fff",
          scrollbarWidth: "none",
        }}
      >
        <NavButton
          title="Menu"
          customFunc={handleActiveMenu}
          color={currentColor}
          icon={<AiOutlineMenu />}
        />
        <div className="flex justify-between items-center">
          <Link
            to="/"
            onClick={handleCloseSideBar}
            className={`items-center gap-3 mt-1 flex text-xl font-extrabold tracking-tight ${
              currentMode === "Dark" ? "dark:text-white" : "text-slate-900"
            } no-underline`}
          >
            <span>
              {activeMenu ? (
                <img
                  src="/doclogo-horizontal.png"
                  alt="DocBox Logo"
                  className="ml-4 h-12 w-48 "
                />
              ) : (
                <img
                  src="/docboxlogo.png"
                  alt="Logo"
                  className="ml-2"
                  style={{ width: "50px" }}
                />
              )}
            </span>
          </Link>
        </div>
        <div className="mt-1">
          {links.map((item) => (
            <div key={item.title}>
              <p
                className={`text-gray-400 dark-text-gray-400 m-3 mt-4 uppercase ${
                  activeMenu ? "block" : "hidden"
                }`}
              >
                {item.title}
              </p>
              {item.links.map((link) => {
                if (link.role === undefined || link.role.includes(userRole)) {
                  return activeMenu ? (
                    <NavLink
                      to={`/${link.name.toLowerCase().replace(/\s+/g, "")}`}
                      key={link.name}
                      onClick={handleCloseSideBar}
                      style={({ isActive }) => ({
                        backgroundColor: isActive ? currentColor : "",
                      })}
                      className={({ isActive }) =>
                        `${
                          isActive ? activeLink : normalLink
                        } custom-navlink-gap-5`
                      }
                    >
                      {({ isActive, isHover }) => (
                        <>
                          <span
                            style={{
                              mask: `url(/icons/${link.icon}) center no-repeat`,
                              WebkitMask: `url(/icons/${link.icon}) center no-repeat`,
                              maskSize: "contain", // Adjust the mask size here
                              WebkitMaskSize: "contain",
                              display: "block",
                              width: "25px",
                              height: "25px",
                              backgroundColor:
                                isActive || isHover
                                  ? "white"
                                  : currentMode === "Dark"
                                  ? "white"
                                  : "#5C5C5C",
                              transition: "background-color 0.3s",
                            }}
                          ></span>
                          <span
                            className={`capitalize ${
                              activeMenu ? "inline" : "hidden"
                            }`}
                          >
                            {link.name}
                          </span>
                        </>
                      )}
                    </NavLink>
                  ) : (
                    <TooltipComponent
                      content={link.name}
                      position="RightCenter"
                      key={link.name}
                    >
                      <NavLink
                        to={`/${link.name.toLowerCase().replace(/\s+/g, "")}`}
                        onClick={handleCloseSideBar}
                        style={({ isActive }) => ({
                          backgroundColor: isActive ? currentColor : "",
                        })}
                        className={({ isActive }) =>
                          `${
                            isActive ? activeLink : normalLink
                          } custom-navlink-gap-5`
                        }
                      >
                        {({ isActive, isHover }) => (
                          <span
                            style={{
                              mask: `url(/icons/${link.icon}) center no-repeat`,
                              WebkitMask: `url(/icons/${link.icon}) center no-repeat`,
                              maskSize: "contain", // Adjust the mask size here
                              WebkitMaskSize: "contain",
                              display: "block",
                              width: "25px",
                              height: "25px",
                              backgroundColor:
                                isActive || isHover
                                  ? "white"
                                  : currentMode === "Dark"
                                  ? "white"
                                  : "#5C5C5C",
                              transition: "background-color 0.3s",
                            }}
                          ></span>
                        )}
                      </NavLink>
                    </TooltipComponent>
                  );
                }
                return null;
              })}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
